import axios from 'axios';

export interface UsuarioFirebaseVinculo {
  vinculado: boolean;
}

export async function fetchUsuarioFirebaseVinculo(): Promise<UsuarioFirebaseVinculo> {
  const { data } = await axios.get<UsuarioFirebaseVinculo>('api/usuario-notificaciones/firebase');
  return data;
}

export async function registrarTokenFirebase(token: string): Promise<void> {
  await axios.post('api/usuario-notificaciones/firebase', { token });
}

export async function enviarNotificacionFirebasePrueba(): Promise<void> {
  await axios.post('api/usuario-notificaciones/firebase/test');
}

export async function limpiarTokensFirebase(): Promise<void> {
  await axios.delete('api/usuario-notificaciones/firebase');
}

export function usuarioFirebaseErrorMessage(error: unknown): string {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data;
    if (typeof data === 'string' && data.trim()) return data;
    if (data && typeof data === 'object' && 'title' in data) {
      const title = (data as { title?: unknown }).title;
      if (typeof title === 'string' && title.trim()) return title;
    }
    if (data && typeof data === 'object' && 'detail' in data) {
      const detail = (data as { detail?: unknown }).detail;
      if (typeof detail === 'string' && detail.trim()) return detail;
    }
    if (error.response?.status === 400) return 'No hay push notifications vinculado.';
    if (error.response?.status === 502) return 'No se pudo enviar la notificación de prueba.';
    if (error.message) return error.message;
  }
  if (error instanceof Error && error.message) return error.message;
  return 'No se pudo completar la operación de push notifications.';
}
